import { IconSet } from '@postscript/components';
import {
  DATA_LABS,
  USAGE_BILLING_ENABLED,
} from 'components/admin/utils/feature-flags';
import { useMemo } from 'react';
import { IS_ADMIN_HOST, MERCHANT_HOST } from 'utils/envVars';
import { NavMenuItem } from '../NavMenu';

export const useAdminMenuItems = (): NavMenuItem[] => {
  return useMemo(
    () => [
      {
        id: 'admin',
        label: 'Postscript Admin',
        icon: IconSet.Key,
        isLoading: false,
        ariaLabelledBy: 'nav-admin-title',
        subMenu: [
          {
            link: '/account-overview',
            label: 'Account Overview',
            id: 'admin-account-overview',
          },
          {
            link: '/admin/migration-downgrade',
            label: 'Migration Downgrade',
            id: 'admin-migration-downgrade',
          },
          {
            link: '/ai-configuration',
            label: 'AI Configuration',
            id: 'admin-ai-configuration',
          },
          {
            link: '/shopper-playground',
            label: 'Shopper Playground',
            id: 'admin-shopper-playground',
          },
          {
            link: '/admin/templates',
            label: 'Templates',
            id: 'admin-templates',
          },
          {
            link: '/admin/billing',
            label: 'Billing',
            id: 'admin-billing',
            featureFlag: USAGE_BILLING_ENABLED,
            featureFlagOptOut: true,
          },
          {
            link: '/admin/messaging-status',
            label: 'Messaging',
            id: 'admin-messaging',
          },
          {
            link: '/admin/announcements',
            label: 'Service Announcements',
            id: 'admin-announcements',
          },
          {
            link: '/admin/ps-labs',
            label: 'PS Labs',
            id: 'admin-ps-labs',
          },
          {
            link: '/admin/shop-labs-features',
            label: 'Shop Labs Features',
            id: 'admin-shop-labs-features',
          },
          {
            link: '/admin/partners',
            label: 'Partners',
            id: 'admin-partners',
          },
          {
            link: '/admin/data-labs',
            label: 'Data Labs',
            id: 'data-labs',
            labsFeatureFlag: DATA_LABS,
          },
          {
            link: '/omni',
            label: 'Omni Sandbox',
            id: 'omni',
          },
          {
            link: '/admin/list-management',
            label: 'List Management',
            id: 'admin-list-management',
          },
          {
            link: '/admin/entitlements',
            label: 'Entitlements',
            id: 'admin-entitlements',
          },
          {
            link: '/admin/pending-plans',
            label: 'Pending Plans',
            id: 'admin-pending-plans',
          },
          {
            link: '/admin/bulk-operations',
            label: 'Bulk Operations',
            id: 'admin-bulk-operations',
          },
          {
            link: '/admin/offer-scanner',
            label: 'Offer Scanner',
            id: 'admin-offer-scanner',
          },
          {
            link: '/admin/automations-cms',
            label: 'Automations CMS',
            id: 'admin-automations-cms',
          },
          {
            link: '/admin/manage-onboarding',
            label: 'Manage Onboarding',
            id: 'admin-manage-onboarding',
          },
          {
            link: '/admin/rcs-gallery',
            label: 'RCS Gallery',
            id: 'admin-rcs-gallery',
          },
          ...(IS_ADMIN_HOST
            ? [
                {
                  link: '/admin/open-on-app',
                  label: `Open on ${MERCHANT_HOST}`,
                  id: 'admin-open-on-app',
                },
              ]
            : []),
        ],
      },
    ],
    [],
  );
};
